import { TipoCarteDaGestire } from './implant';

export class UserManageInfo {
  Id: string;
  Nome: string;
  Cognome: string;
  Email: string;
  Ruolo: string;
  IdImpianto: number;
  IdImpiantiOperatore: number[];
  IsAmministratore: boolean;
  HasCasse: boolean;
  HasBloccoCartaCash: boolean;
  GestisceStandAlone: boolean;
  GestisceSecondaFasciaOrariaStandAlone: boolean;
  TipoCarteDaGestire: TipoCarteDaGestire;
  TwoFactorEnabled: boolean;
  IsSilicloudAbilitato: boolean;

  constructor() {
    this.TipoCarteDaGestire = new TipoCarteDaGestire();
  }
}





// WEBPACK FOOTER //
// ./src/app/models/userManageInfo.ts